import Dashboard from './Components/Dashboard';

function App() {
  return <Dashboard />;
}

export default App;
